import { CustomSignUp } from '@/components/auth/custom-sign-up';
import { PartnerOtpSignIn } from '@/components/auth/partner-otp-sign-in';
import { resolveSatellite } from '@/config/clerk-satellite';

/**
 * Sign-up entry point.
 *
 *  - Primary host → <CustomSignUp /> (Clerk signUp.create + Google).
 *  - Partner whitelabel satellite → <PartnerOtpSignIn mode="sign-up" />.
 *    Clerk blocks signUp.create on satellites and we must not show a
 *    Google button (it would leak the "Tagada" OAuth app name), so the
 *    partner sign-up is the same self-owned OTP exchange as sign-in —
 *    the backend's lookup-or-create makes it an implicit sign-up.
 */
export default function SignUpPage() {
  const satellite = resolveSatellite();

  if (satellite) {
    return <PartnerOtpSignIn mode="sign-up" />;
  }

  return <CustomSignUp />;
}
